import React, { forwardRef, ComponentProps } from 'react';

import Icon, { IconWithRender, generateRenderedIcon } from './Icon';
import { VIEWBOXES } from '../consts';
import { IconVariations } from '../useIconVariation';

const draw16px =
  'M9.94 14.68H6.06a2.76 2.76 0 0 1-2.75-2.75V4a2.75 2.75 0 0 1 2.75-2.76h3.88A2.75 2.75 0 0 1 12.69 4v7.94a2.75 2.75 0 0 1-2.75 2.74ZM6.06 2.74A1.25 1.25 0 0 0 4.81 4v7.94a1.25 1.25 0 0 0 1.25 1.25h3.88a1.25 1.25 0 0 0 1.25-1.25V4a1.25 1.25 0 0 0-1.25-1.26ZM8 11a.9.9 0 1 0 .9.9.9.9 0 0 0-.9-.9Z';
const draw24px =
  'M16,21.84H8a2.75,2.75,0,0,1-2.75-2.75V4.91A2.75,2.75,0,0,1,8,2.16h8a2.75,2.75,0,0,1,2.75,2.75V19.09A2.75,2.75,0,0,1,16,21.84ZM8,3.66A1.25,1.25,0,0,0,6.75,4.91V19.09A1.25,1.25,0,0,0,8,20.34h8a1.25,1.25,0,0,0,1.25-1.25V4.91A1.25,1.25,0,0,0,16,3.66Zm4,13A1.37,1.37,0,1,0,13.37,18,1.37,1.37,0,0,0,12,16.63Z';

const icons: IconVariations = {
  _16: { d: draw16px, viewBox: VIEWBOXES._16 },
  _24: { d: draw24px, viewBox: VIEWBOXES._24 },
};

const MobilePhoneIcon = forwardRef<SVGSVGElement, ComponentProps<typeof Icon>>(
  generateRenderedIcon(icons, 'mobilePhone'),
) as IconWithRender;

MobilePhoneIcon.displayName = 'MobilePhoneIcon';
MobilePhoneIcon.propTypes = Icon.propTypes;
MobilePhoneIcon.renderIcon = (props) => <MobilePhoneIcon {...props} />;
export default MobilePhoneIcon;
